import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from "../../components/GreyCard/GreyCard";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {Button, Col, ProgressBar} from "react-bootstrap";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Центр повышения квалификации работников </h1>
            </StartStep>

            <GreyCard>
                <h2>Формы повышения квалификации работников НИУ ВШЭ и виды мероприятий:</h2>
                <ul>
                    <li>программы повышения квалификации различной продолжительности, проводимые на базе подразделений
                        (факультетов, кафедр, институтов) НИУ ВШЭ;
                    </li>
                    <li>краткосрочные программы повышения квалификации (до 20 часов), включая лекционно-семинарские
                        циклы, мастер-классы, групповые тренинги, проводимые на базе профильных подразделений НИУ ВШЭ
                        или его филиалов;
                    </li>
                    <li>выездные мероприятия по повышению квалификации, включая летние школы, краткосрочные курсы и
                        семинары в филиалах, проводимые сотрудниками НИУ ВШЭ;
                    </li>
                    <li>дистанционное интерактивное обучение, в т.ч. мастер-классы, курсы обучения, семинары, групповые
                        тренинги, проводимые подразделениями НИУ ВШЭ;
                    </li>
                    <li>индивидуальные стажировки в подразделениях НИУ ВШЭ или его филиалах;</li>
                    <li>совместная научно-исследовательская или проектная деятельность, в том числе с участием
                        работников других вузов, а также зарубежных специалистов;
                    </li>
                    <li>программы повышения квалификации, проводимые приглашенными специалистами, другими вузами или
                        специализированными организациями, в том числе зарубежными, на базе НИУ ВШЭ и его филиалов;
                    </li>
                    <li>курсы повышения квалификации на базе других вузов, научных центров и специализированных
                        организаций, в том числе зарубежных;
                    </li>
                    <li>педагогические и научные стажировки, целевые стажировки (для административно-управленческого
                        персонала) в других вузах, исследовательских центрах и специализированных организациях, в том
                        числе зарубежных, а также участие в конференциях и других научных мероприятиях.
                    </li>
                </ul>
            </GreyCard>

            <br/><br/>

            <GreyCard>
                <h2>Формы повышения квалификации в вузах-партнерах</h2>
                <ul>
                    <li> программы краткосрочного (менее 72 часов) тематического обучения по вопросам конкретной
                        деятельности слушателей (со сдачей соответствующего экзамена, зачета или защитой реферата и
                        последующей выдачей сертификата о краткосрочном повышении квалификации НИУ ВШЭ);
                    </li>
                    <li> программы тематических и проблемных семинаров (от 72 до 100 часов) по актуальным проблемам в
                        предметных областях деятельности слушателей (со сдачей соответствующего экзамена, зачета или
                        защитой реферата и последующей выдачей слушателям, успешно завершившим курс обучения,
                        удостоверения о повышении квалификации);
                    </li>
                    <li> программы длительного (свыше 100 часов) обучения специалистов для углубленного изучения
                        актуальных проблем в предметных областях деятельности слушателей (со сдачей соответствующего
                        экзамена, зачета или защитой реферата и с последующей выдачей слушателям, успешно завершившим
                        курс обучения, свидетельства о повышении квалификации).
                    </li>
                </ul>
                <p> Такие программы повышения квалификации могут организовываться как на базе НИУ ВШЭ, так и на
                    базе вузов-партнеров на договорной основе
                </p>
                <p> Конкретные предложения по программам представлены на странице <a href="https://www.hse.ru/cpk/offer">Курсы для вузов-партнеров</a></p>
                <br/>
                <p><a href="https://www.hse.ru/cpk/">Центр повышения квалификации</a></p>
            </GreyCard>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step9">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={90}/>
                        <span>Шаг 10 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step11">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;